import React, { useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import user from "../assets/images/user.png";
import dropdown from "../assets/images/dropdown.png";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import storageService from "../services/Storage";
import { Formik } from "formik";
import { ToastContainer } from "react-toastify";
import { showToast } from "./ShowToast";
import http from "../services/http";
import GetStorage from "../services/Storage";

function DropdownRight(props) {
  const [showModal, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setError("");
    setMessage("");
  };

  const handleShow = () => setShow(true);
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loader, setLoader] = useState(false);

  const token = GetStorage.get("xAuthToken");

  const initialValues = {
    email: "",
    password: "",
  };

  const onSubmit = async (values) => {
    http
      .post(`api/coach/changepin?token=${token}`)
      .then((res) => {
        console.log("added new user", res.data);

        setMessage(res.data.message);
        // handleClose();
      })
      .catch((error) => {
        console.log("error ", error.response.data.errors);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  let user = localStorage.getItem("user");

  user = JSON.parse(user);

  const signOutUser = () => {
    try {
      storageService.remove("user");
      storageService.remove("xAuthToken");
      storageService.remove("xAuth");

      navigate("/");
    } catch (e) {
      console.log("logout error", e);
    }
  };

  return (
    <>
      <div className="user_profile   ">
        <div className="collapse navbar-collapse show" id="navbar-list-4">
          <Dropdown className="navbar-nav">
            <Dropdown.Toggle className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                // href="#"
                id="navbarDropdownMenuLink"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {user.data.image ? (
                  <img
                    alt=""
                    src={user.data.image}
                    className="user_profile_imga"
                  />
                ) : (
                  <p style={{ display: "inline-block", color: "black" }}>
                    {user.data.email}
                  </p>
                )}
                <img src={dropdown} className="ml-2 user_profile_icon" alt="" />
              </a>
            </Dropdown.Toggle>
            <Dropdown.Menu
              className="dropdown-menu"
              aria-labelledby="navbarDropdownMenuLink"
            >
              <Dropdown.Item
                as={Link}
                to="/editProfile"
                className="dropdown-item"
              >
                Edit Profile
              </Dropdown.Item>

              <Dropdown.Item
                as={Link}
                to="/accountSettings"
                ClassName="dropdown-item"
              >
                Account Setting
              </Dropdown.Item>

              <Dropdown.Item as={Link} to="/logout" ClassName="dropdown-item">
                Feed Backs
              </Dropdown.Item>

              {/*  <Dropdown.Item
            ClassName="dropdown-item"
            as={Link}
            to="/wallet"
            // href="/wallet"
          >
            <a class="dropdown-item">Wallet</a>
          </Dropdown.Item>
          <Dropdown.Divider /> */}
              <Dropdown.Item
                ClassName="dropdown-item"
                //  href="/wallet"
                onClick={signOutUser}
              >
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Request PIN Reset</Modal.Title>
          <button
            onClick={handleClose}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            {" "}
            <span aria-hidden="true">&times;</span>{" "}
          </button>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={initialValues}
            // validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ values, handleChange, handleBlur, handleSubmit }) => (
              <>
                <div className="modal-body">
                  <p>
                    Are you sure you want to ask admin to reset your password
                    PIN?
                  </p>

                  <div className="modal-footer border-top-0">
                    {" "}
                    <button
                      type="button"
                      className="them_btn_ouline "
                      onClick={handleClose}
                    >
                      Cancel
                    </button>{" "}
                    <button
                      type="button"
                      className="them_btn "
                      onClick={handleSubmit}
                    >
                      Request Reset
                    </button>
                  </div>
                  <h5 style={{ color: "green" }}>{message}</h5>
                  <h5 style={{ color: "red" }}>{error}</h5>
                </div>
              </>
            )}
          </Formik>
        </Modal.Body>
        <ToastContainer />
      </Modal>
    </>
  );
}

export default DropdownRight;
